//
//  I12VOLINSTCHAUFI18n.js
//
//  Created by Sébastien Hecart on 2017-11-24 21:21:42 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

export default {
  I12VOLINSTCHAUF_SECTION_0_TITLE: "Calculez le volume d'eau de chauffage que vous avez dans votre installation.",
  I12VOLINSTCHAUF_ch_puissanceAcier: 'Volume chaudière',
  I12VOLINSTCHAUF_ch_puissanceFonte: 'Volume chaudière Pompe à chaleur',
  I12VOLINSTCHAUF_SECTION_1_TITLE: 'Volume Radiateur',
  I12VOLINSTCHAUF_rad_panneau: 'Panneaux acier',
  I12VOLINSTCHAUF_rad_fonte: 'Elément en fonte',
  I12VOLINSTCHAUF_rad_alu: 'Elément en fonte aluminium',
  I12VOLINSTCHAUF_rad_conv: 'Convecteur',
  I12VOLINSTCHAUF_SECTION_2_TITLE: 'Volume conduite',
  I12VOLINSTCHAUF_cond_bi: 'Distribution Bi-tude',
  I12VOLINSTCHAUF_cond_mono: 'Distribution mono-tube',
  I12VOLINSTCHAUF_SECTION_3_TITLE: 'Réseau Urbain',
  I12VOLINSTCHAUF_in_dn: 'Diamètre DN',
  I12VOLINSTCHAUF_in_longeur: 'Longueur',
  I12VOLINSTCHAUF_SECTION_4_TITLE: '',
  I12VOLINSTCHAUF_result: 'Volume Total',
  I12VOLINSTCHAUFDETAIL_SECTION_0_TITLE: 'Saisir le volume',
  I12VOLINSTCHAUFDETAIL_SECTION_1_TITLE: 'Calculer le volume',
  I12VOLINSTCHAUFDETAIL_in_volume: 'Volume',
  I12VOLINSTCHAUFDETAIL_in_puissance: 'Puissance',
  I12VOLINSTCHAUFDETAIL_in_contenance: 'Contenance en eau'
}
